module.exports = __webpack_public_path__ + "img/bim (8).4aefa2f0.png";